import React, { Component } from 'react'
import { connect } from 'react-redux'

// Components
import ModalContainer from '../ModalContainer'
import YouTubePlayer from '../../Global/YouTubePlayer'

// Actions
import { hideModal } from '../../../actions/modal'

class MarketingLearnMoreModal extends Component {
  render() {
    const {
      heading,
      description,
      videoId
    } = this.props;

    return (
      <ModalContainer
        modalExit={true}
      >
        <header>
          <h2>
            { heading ? heading : "Learn More"}
          </h2>
        </header>
        <YouTubePlayer
          videoId={videoId}
        />
        <p>
          { description }
        </p>
        <a className="cta" href="/sign-up">Sign Up Now</a>
      </ModalContainer>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    hideModal: modalType => {
      dispatch(hideModal())
    }
  }
}

export default connect(
  null,
  mapDispatchToProps
)(MarketingLearnMoreModal)



// WEBPACK FOOTER //
// ./src/components/Modals/Marketing/MarketingHowItWorksModal.js